module.exports = __webpack_public_path__ + "img/pile-file.4ee81573.svg";